/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Gift_Refund_HintInputs */

const vi_order_gift_refund_hint = /** @type {(inputs: Order_Gift_Refund_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ / hoàn đơn: ERP không tự hoàn tiền ship — xử lý tay.`)
};

/**

* @param {Order_Gift_Refund_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_refund_hint = /** @type {((inputs?: Order_Gift_Refund_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_Refund_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_refund_hint(inputs)
});